import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import FilterOption from './FilterOption';
import { partyProjectsData, getTemperatureColor } from './mockData';
import './DataVisualization.css';

const DataVisualization = ({ className = '' }) => {
  const [activeFilters, setActiveFilters] = useState([]);
  const [selectedState, setSelectedState] = useState('TODOS');
  const [searchQuery, setSearchQuery] = useState('');
  const [filteredParties, setFilteredParties] = useState([]);
  
  const filterOptions = [
    { id: 'candidatos', label: 'Candidatos 2025', icon: '📋' },
  ];
  
  const states = [
    'TODOS', 'AC', 'AL', 'AM', 'AP', 'BA', 'CE', 'DF', 'ES', 'GO', 
    'MA', 'MG', 'MS', 'MT', 'PA', 'PB', 'PE', 'PI', 'PR', 'RJ', 
    'RN', 'RO', 'RR', 'RS', 'SC', 'SE', 'SP', 'TO'
  ];
  
  const temperatureLabels = ['37°', '38°', '39°', '40°', '41°', '42°'];
  
  // Filter parties based on search query
  useEffect(() => {
    let result = [...partyProjectsData];
    
    if (searchQuery.trim() !== '') {
      result = result.filter(item => 
        item.party.toLowerCase().includes(searchQuery.toLowerCase())
      );
    }
    
    // Sort by project count (descending)
    result = result.sort((a, b) => b.projects - a.projects);
    
    setFilteredParties(result);
  }, [searchQuery, activeFilters, selectedState]);
  
  const toggleFilter = (filterId) => {
    setActiveFilters(prev => 
      prev.includes(filterId) 
        ? prev.filter(id => id !== filterId) 
        : [...prev, filterId]
    );
  };
  
  const handleStateChange = (e) => {
    setSelectedState(e.target.value);
  };
  
  const handleSearchChange = (e) => {
    setSearchQuery(e.target.value);
  };
  
  // Get the top 5 parties by project count
  const topParties = filteredParties.slice(0, 5);
  
  return (
    <section className={`data-visualization ${className}`}>
      <h2>CLIQUE NOS FILTROS</h2>
      
      <div className="filters-container">
        {filterOptions.map(filter => (
          <FilterOption 
            key={filter.id}
            icon={filter.icon}
            label={filter.label}
            isActive={activeFilters.includes(filter.id)}
            onClick={() => toggleFilter(filter.id)}
          />
        ))}
      </div>
      
      <div className="search-controls">
        <div className="state-selector">
          <select value={selectedState} onChange={handleStateChange}>
            {states.map(state => (
              <option key={state} value={state}>{state}</option>
            ))}
          </select>
        </div>
        
        <div className="deputy-search">
          <input 
            type="text" 
            placeholder="Digite o nome do partido" 
            value={searchQuery}
            onChange={handleSearchChange}
          />
        </div>
      </div>
      
      <div className="chart-container">
        <div className="temperature-scale"></div>
        <div className="temperature-labels">
          {temperatureLabels.map(label => (
            <span key={label}>{label}</span>
          ))}
        </div>
        
        {/* Thermometer visualization */}
        <div className="thermometer-visualization">
          {topParties.map((party, index) => (
            <div 
              key={party.party} 
              className="party-thermometer"
              style={{
                left: `${10 + (index * 18)}%`,
              }}
            >
              <div 
                className="thermometer-bar" 
                style={{
                  height: `${(party.projects / 150) * 100}%`,
                  backgroundColor: getTemperatureColor(party.temperature)
                }}
              ></div>
              <div className="party-name">{party.party}</div>
              <div className="project-count">{party.projects}</div>
              <div className="temperature-value">{party.temperature}°</div>
            </div>
          ))}
        </div>
      </div>
      
      <div className="party-labels">
        {partyProjectsData.map(party => (
          <span 
            key={party.party} 
            className={topParties.some(p => p.party === party.party) ? 'highlighted' : ''}
          >
            {party.party}
          </span>
        ))}
      </div>
      
      <div className="footnote">
        * Esta é a primeira pesquisa de campo com abrangência nacional focada em cripto.
      </div>
    </section>
  );
};

DataVisualization.propTypes = {
  className: PropTypes.string
};

export default DataVisualization;
